/**
 * A normal sale appraisal form without beds, baths, cars.
 *
 * TODO: Refactor to reduce duplication.
 */
import React from 'react'
import PropTypes from 'prop-types'
import { reduxForm, propTypes } from 'redux-form'
import {
  emailOrNumber,
  types,
} from '@raywhite/helpers-utils/lib/helpers/validation'
import {
  formSchemaValidator,
  stockFormEmail,
  schemafy,
  schemaItem,
  schemaFields,
  schemaLabels,
  schemaRules,
  schemaInitialValues,
} from '@raywhite/functionalities-utils/lib/functionalities/form'
import {
  FormSectionHeading,
  FormSection,
  FormTextArea,
  FormSubmit,
  FormRow,
  labelifyFormField,
} from '../../presentational/formComponents'
import ContentForm from './ContentForm.jsx'

const FORM_NAME = 'commercialAppraisal'
const schema = schemafy(
  schemaItem('name', 'Your Full Name', types.fullName.required()),
  schemaItem('email', 'Your Email', types.email.allow('').empty('')),
  schemaItem('number', 'Your Phone Number', types.phone.allow('').empty('')),
  schemaItem('message', 'Additional Message', types.freeText.allow('')),
  schemaItem('street', 'Street Address', types.freeText.required()),
  schemaItem('suburb', 'Suburb and Postcode', types.freeText.required()),
  schemaItem('details', 'Additional Details', types.freeText.allow('')),
)
export const fields = schemaFields(schema)
export const labels = schemaLabels(schema)
const FormField = labelifyFormField(labels)
const initialValues = schemaInitialValues(schema)
export const validate = formSchemaValidator(
  fields, emailOrNumber.concat(schemaRules(schema))
)
export const process = (values, { send, referrer }) => stockFormEmail(
  send,
  'Commercial Sale Appraisal Request',
  fields,
  labels,
  values,
  {
    prefix: `A commercial sale appraisal request has been received from ${referrer || 'your office website'}.`,
    referrer,
  }
)

const CommercialSellAppraisalForm = props => {
  const {
    fields: { name, email, number, message, street, suburb, details },
    submitting,
    sendForm,
    handleSubmit,
    error,
    dispatch,
    showCloseButton,
    handleClose,
  } = props

  return (
    <ContentForm
      dispatch={dispatch}
      sendForm={sendForm}
      formName={FORM_NAME}
      handleSubmit={handleSubmit}
      error={error}
      showCloseButton={showCloseButton}
      handleClose={handleClose}
    >
      <FormSectionHeading>Your Contact Details</FormSectionHeading>
      <FormSection>
        <FormField field={name} placeholder="e.g. Joe Bloggs" required />
        <FormRow>
          <FormField
            field={number}
            placeholder="e.g. 04xx xxx xxx"
            required={!email.value}
            className="one_half"
          />
          <FormField
            field={email}
            placeholder="e.g. j.bloggs@gmail.com"
            required={!number.value}
            className="one_half"
          />
        </FormRow>
        <FormField field={message} input={FormTextArea} />
      </FormSection>
      <FormSectionHeading>Property Details</FormSectionHeading>
      <FormSection>
        <FormField field={street} placeholder="e.g. 123 Example Street" />
        <FormField field={suburb} placeholder="City, Suburb, Postcode" />
        <FormField field={details} input={FormTextArea} />
      </FormSection>
      <FormSubmit submitting={submitting} label="Request an Appraisal" />
    </ContentForm>
  )
}

CommercialSellAppraisalForm.propTypes = {
  ...propTypes,
  sendForm: PropTypes.func.isRequired,
  showCloseButton: PropTypes.bool,
  handleClose: PropTypes.func,
}

export default reduxForm({
  form: FORM_NAME,
  fields,
  validate,
  initialValues,
})(CommercialSellAppraisalForm)
